import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LocalStoreEnums } from '../enums/store.enum';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  public getCookie(name: LocalStoreEnums) {
    if (isPlatformBrowser(this.platformId)) {
      let ca: Array<string> = document.cookie.split(';');
      let caLen: number = ca.length;
      let cookieName = `${name}=`;
      let c: string;

      for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
          return c.substring(cookieName.length, c.length);
        }
      }
    }
    return '';
  }

  public deleteCookie(cookieName: LocalStoreEnums) {
    this.setCookie({ name: cookieName, value: '', expireDays: -1 });
  }

  public setCookie(params: Cookie) {
    const isObValue = typeof params?.value === 'object';
    const value = isObValue ? JSON.stringify(params.value) : params.value;

    if (isPlatformBrowser(this.platformId)) {
      let d: Date = new Date();
      d.setTime(
        d.getTime() +
          (params.expireDays ? params.expireDays : 1) * 24 * 60 * 60 * 1000
      );
      document.cookie =
        (params.name ? params.name : '') +
        '=' +
        (value ? value : '') +
        ';' +
        (params.expiration && params.expiration == true
          ? 'expires=' + d.toUTCString() + ';'
          : '') +
        'path=' +
        (params.path && params.path.length > 0 ? params.path : '/') +
        ';' +
        (location.protocol === 'https:' &&
        params.secure &&
        params.secure == true
          ? 'secure'
          : '');
    }
  }
}

export interface Cookie {
  name: LocalStoreEnums;
  value: any;
  expireDays?: number;
  path?: string;
  secure?: boolean;
  expiration?: boolean;
}
